import { otaUrl } from "../api/endpoints";
//import React, { useContext, useEffect, useState } from "react";
import React, { useEffect, useState, useContext, useCallback } from "react";
//import Table from '../Components/Table';
import axios from 'axios';
import moment from 'moment';
//import CollapseContext from "../hooks/CollapseContext";
import { useAuth } from "../hooks/AuthProvider";
//import useWindowDimensions from "../hooks/useWindowDimensions";

import { DeleteIcon } from "../Icons";
import { useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/InfoOutlined';
import PauseIcon from '@mui/icons-material/PauseCircleOutlined';
import ResumeIcon from '@mui/icons-material/PlayCircleOutlined';
import CancelIcon from '@mui/icons-material/CancelOutlined';
import FileIcon from '@mui/icons-material/TaskOutlined';
import '../Components/modal.css';
import './edit.css';
import './Shipments.css';
import { deleteShipment, controlShipment, deleteMultiShipments } from '../lib/actions';
import DataGridTable from "../Components/DataGridTable";
import Spinner from "../Components/Spinner";
import { GridActionsCellItem } from '@mui/x-data-grid';
import { defaultShipmentIcon, STATIC_ICONS } from "../Constants";

import { LanguageContext } from '../context/LanguageContext';
import shipmentsTranslations from '../languages/shipment.json';
import Alert from '../Components/Alert';
import { getErrorMessage } from '../utils/errorUtils';



const shipmentKeys = ['tid', 'build', 'firmware', 'type', 'md5_checksum', 'file_size'];

export const ShipmentInfo = ({ state, setState, initialData }) => {
	const { lang } = useContext(LanguageContext);
	const tRoot = shipmentsTranslations[lang] || shipmentsTranslations.en;
	const t = tRoot.shipmentInfoFields;
	const isRtl = ['ar', 'ur'].includes(lang);
	const [alertState, setAlertState] = useState({
		open: false,
		message: '',
		type: 'info',
		position: isRtl ? 'left' : 'right'
	});
	const showAlert = useCallback((type, message) => {
		setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
	}, [isRtl]);
	const labels = tRoot.shipmentInfoLabels;
	const [data, setData] = useState(initialData ? initialData : {
		id: 0,
		name: '',
		tid: '',
		template_name: '',
		dids: [],
		target_size: 0,
		apply_if: 'earlier build date',
		preffered_time: 'any',
		host: '',
		file: '',
		file_size: '',
		md5_checksum: '',
		firmware: '',
		type: '',
		build: '',
		attempts_limit: 3,
		attempts_reset_period: 24,
		attempts_reset_period_unit: 'hours',
		notification: false,
		start_date: '',
		status: ''
	});

	useEffect(() => {
		if (data.id !== 0 || !state.id) {
			return;
		}

		const fetchShipmentData = async () => {
			try {
				const res = await axios.get(otaUrl(`shipment/get/${state.id}`));

				if (res.data && res.data.status === 'OK') {
					setData(res.data.data);
				} else {
					throw new Error('Received an invalid response from the server.');
				}
			} catch (err) {
				console.error("Fetch Shipment Error:", err);
				const errorMessage = getErrorMessage(err);
				showAlert('error', errorMessage);
			}
		};

		fetchShipmentData();

	}, [state.id, data.id, showAlert]);

	return <div id="modal">
		<Alert
			open={alertState.open}
			close={() => setAlertState({ ...alertState, open: false })}
			message={alertState.message}
			type={alertState.type}
			position={alertState.position}
		/>
		<div
			id="popup"
			className={`dashboard-modal shipments-info-modal${isRtl ? ' rtl' : ''}`}
			dir={isRtl ? 'rtl' : 'ltr'}
		>
			<div className="dashboard-header">
				<div className="dashboard-header-icon shipments-info-header-icon">
					<FileIcon />
				</div>
				<div className="dashboard-header-text">
					<h2>{data.name}</h2>
					<p>{data.template_name || data.firmware || data.file}</p>
				</div>
			</div>
			<div className="modal-content dashboard-content shipments-info-content">
				<div className="shipments-info-layout">
					<div className="shipments-info-file-card">
						<div className="shipments-info-file-icon">
							<FileIcon />
						</div>
						<div className="shipments-info-file-name">
							{data.file || data.firmware || data.name}
						</div>
						<div className="shipments-info-chip">
							<span>{labels.target}</span>
							<strong>{data.target_size}</strong>
						</div>
					</div>

					<div className="shipments-info-field-list">
						{shipmentKeys.map((key) => (
							<div key={key} className="shipments-info-field-row">
								<span className="shipments-info-field-key">{t[key]}</span>
								<span className="shipments-info-field-value">
									{data[key] || '-'}
								</span>
							</div>
						))}
					</div>
				</div>

				<div className="shipments-info-grid">
					<div className="shipments-info-panel">
						<label>{labels.attemptsLimit}</label>
						<div className="shipments-info-readonly">{data.attempts_limit}</div>
					</div>

					<div className="shipments-info-panel">
						<label>{labels.attemptsResetPeriod}</label>
						<div className="shipments-info-readonly split">
							<span>{data.attempts_reset_period}</span>
							<span className="shipments-info-unit">
								{data.attempts_reset_period_unit}
							</span>
						</div>
					</div>

					<div className="shipments-info-panel">
						<label>{labels.host}</label>
						<div className="shipments-info-readonly">{data.host || '-'}</div>
					</div>

					<div className="shipments-info-panel">
						<label>{labels.applyIf}</label>
						<div className="shipments-info-readonly">{data.apply_if || '-'}</div>
					</div>

					<div className="shipments-info-panel">
						<label>{labels.preferredTime}</label>
						<div className="shipments-info-readonly">{data.preffered_time || '-'}</div>
					</div>
				</div>
			</div>
			<div className="modal-footer dashboard-footer shipments-info-footer">
				<div className="modal-footer-right-buttons">
					<button
						className="btn btn-cancel"
						onClick={() => setState(prev => ({ ...prev, opened: false }))}
					>
						{labels.cancel}
					</button>
				</div>
			</div>
		</div>
	</div>
};

export const SamaOTA = () => {
	const { lang } = useContext(LanguageContext);
	const tPage = shipmentsTranslations[lang] || shipmentsTranslations.en;
	const isRtl = ['ar', 'ur'].includes(lang);
	const [alertState, setAlertState] = useState({
		open: false,
		message: '',
		type: 'info',
		position: isRtl ? 'left' : 'right'
	});
	const showAlert = useCallback((type, message) => {
		setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
	}, [isRtl]);
	const [rows, setRows] = useState([])
	const [loading, setLoading] = useState(false)
	const [openDetails, setOpenDetails] = useState({ opened: false, id: 0 })
	const { permissions } = useAuth()
	const navigate = useNavigate()
	const fetchShipments = useCallback(async () => {
		setLoading(true);
		try {
			const result = await axios.get(otaUrl(`shipment/list`));

			if (result.data && result.data.status === 'OK') {
				setRows(Array.isArray(result.data.data) ? result.data.data : []);
			} else {
				throw new Error('Received an invalid response from the server.');
			}
		} catch (err) {
			console.error("Fetch Shipments Error:", err);
			const errorMessage = getErrorMessage(err);
			showAlert('error', errorMessage);
			setRows([]);
		} finally {
			setLoading(false);
		}
	}, [showAlert]);


	useEffect(() => {
		fetchShipments();
	}, [fetchShipments]);
	const handleMultiDelete = (ids) => {
		const firmwares = []
		ids.forEach(id => {
			const selectedRow = rows.find(row => row.id === id);
			if (selectedRow) {
				firmwares.push(selectedRow.firmware);
			}
		});
		deleteMultiShipments(ids, firmwares, fetchShipments, showAlert)
		setSelectedRows([])
	};

	const handleRowClick = (params) => {
		navigate('/configuration/ota/shipment/' + params.row.id)
	};

	const pagingoptions = [10, 20, 50, 100]
	const columns = [
		{
			field: 'actions', headerName: tPage.column.actions, type: 'actions', width: 100,
			getActions: (params) => [
				permissions['stop_pause_shipments'] ?
					<GridActionsCellItem icon={<PauseIcon />} showInMenu label={tPage.actions.pause} onClick={() => controlShipment(params.row.id, 'pause', fetchShipments, showAlert)} />
					: null,
				permissions['stop_pause_shipments'] ?
					<GridActionsCellItem icon={<ResumeIcon />} showInMenu label={tPage.actions.resume} onClick={() => controlShipment(params.row.id, 'resume', fetchShipments, showAlert)} />
					: null,
				<GridActionsCellItem icon={<InfoIcon />} showInMenu label={tPage.actions.details} onClick={() => setOpenDetails({ opened: true, id: params.row.id })} />,
				<GridActionsCellItem icon={<CancelIcon style={{ color: 'red' }} />} showInMenu label={tPage.actions.cancel} onClick={() => controlShipment(params.row.id, 'cancel', fetchShipments, showAlert)} />,
				<GridActionsCellItem icon={<DeleteIcon style={{ color: 'red' }} />} showInMenu label={tPage.actions.delete} onClick={() => deleteShipment(params.row.id, params.row.firmware, fetchShipments, showAlert)} />,
			].filter(Boolean) // Filter out null actions if permissions are false
		},
		{
			field: 'icon', headerName: '', width: 70, align: 'center',
			renderCell: (params) => (
				<img
					src={STATIC_ICONS + defaultShipmentIcon}
					className="shipment-cell-icon"
					alt=""
				/>
			)
		},
		{ field: 'id', headerName: tPage.column.id, width: 100, align: 'center', headerAlign: 'center' },
		{ field: 'name', headerName: tPage.column.name, width: 200, align: 'center', headerAlign: 'center' },
		{ field: 'status', headerName: tPage.column.status, width: 100, align: 'center', headerAlign: 'center' },
		{ field: 'target_size', headerName: tPage.column.targetSize, width: 100, type: 'number', align: 'center', headerAlign: 'center' },
		{ field: 'firmware', headerName: tPage.column.firmware, width: 100, align: 'center', headerAlign: 'center' },
		{ field: 'template_name', headerName: tPage.column.templateName, width: 300, align: 'center', headerAlign: 'center' },
		{ field: 'start_date', headerName: tPage.column.startDate, type:'dateTime' ,valueGetter: (params) => params ? new Date(params) : null, valueFormatter: (params) => moment(params).format('DD/MM/YYYY HH:mm:ss'), width: 200, align: 'center', headerAlign: 'center' },
		
	];
	useEffect(() => {
		fetchShipments();
	}, [fetchShipments]);
	const [selectedRows, setSelectedRows] = React.useState([]);
	let selectActions = [
		permissions['delete_users'] ? // Note: Should probably be 'delete_shipments' based on context, but using 'delete_users' as per original code's check for array-select action
			{
				title: tPage.actions.delete,
				icon: <DeleteIcon style={{ color: 'rgb(236, 69, 78)', marginInlineEnd: '20px' }} />,
				action: (ids) => { handleMultiDelete(ids); }
			} : null
	].filter(Boolean); // Filter out null if permission is false

	return (
		permissions['firmware_get_access'] ?
				<div
					className="configuration devices-page "
					dir={isRtl ? 'rtl' : 'ltr'}
				>
					<Alert
						open={alertState.open}
						close={() => setAlertState({ ...alertState, open: false })}
						message={alertState.message}
						type={alertState.type}
						position={alertState.position}
					/>
					{openDetails.opened ? <ShipmentInfo state={openDetails} setState={setOpenDetails} /> : null}
					
					<div className="device-main shipments-main">
						<div className="devices-header">
							<div className="devices-header-left shipments-header-left">
								<h2 className="devices-title">{tPage.shipmentsPageTitle}</h2>
							</div>
							{permissions['create_new_firmware_shipments'] ?
								<button className="devices-primary-btn shipments-create-btn"
									onClick={() => navigate('/configuration/ota/create')}>
									<span>{tPage.newShipment}</span>
								</button> : null}
						</div>

						{loading && rows.length === 0 ? (
							<Spinner />
						) : rows.length > 0 ? (
							<div className="devices-grid-wrapper shipments-grid-wrapper">
							<DataGridTable columns={columns} rows={rows} handleRowClick={handleRowClick} idcolumn={"id"} pagingoptions={pagingoptions}
								checkboxSelection={true}
								rowSelectionModel={selectedRows} setRowSelectionModel={setSelectedRows} selectActions={selectActions}
								showToolbar={true}
								tableKey='shipments'
								loading={loading}>
							</DataGridTable>
							</div>
						) : (
							<div className="devices-grid-wrapper shipments-grid-wrapper">
								<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									{tPage.noData}
								</div>
							</div>
						)}
					</div>
				</div>
				: <div>{tPage.noPermission}</div>
	);
};
